import Validate from '../validate';

export function areEmailsValid(emails) {
  return emails.length < 1
    ? false
    : emails.reduce((previousValue, currentValue) => {
        return previousValue && Validate.validate('email', currentValue);
      }, true);
}
